import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import gql from 'graphql-tag';
import { ModalDirective, TabHeadingDirective, ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { cliente_proveedor } from 'src/app/shared/object/cliente_proveedor.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import { FormDatosComercialesComponent } from '../form-datos-comerciales/form-datos-comerciales.component';
import { ClientesService } from 'src/app/services/clientes.service';
import { TipoMensaje } from 'src/Wheel.Styles.HighVolume/Mensaje';
import { MANTENEDOR_CLIENTES_MODULO, OP_EDICION_DATOS_COMERCIALES } from '../cliente-mantenedor.constants';

@Component({
  selector: 'app-mantenedor-clientes-modal-datos-comerciales',
  templateUrl: './modal-datos-comerciales.component.html',
  styleUrls: ['../clientes.component.scss'],
  providers: [SecurityService, ValidadoresService],
})
export class MantenedorClientesModalDatosComercialesComponent implements OnInit {

  // Outputs
  @Output() onSuccess: EventEmitter<void> = new EventEmitter<void>()

  private client: GraphQLClient = null;

  // Modales
  @ViewChild('datosComerciales', { static: true }) datosComercialesModal: ModalDirective;
  @ViewChild(FormDatosComercialesComponent, { static: true }) formDatosComerciales: FormDatosComercialesComponent

  // Data & Tmp
  public rutEmpresa: number;
  public sucursalEmpresa: number;
  public codigoModulo: number;
  public rutUsuario: number

  // Utils
  private log: any

  public clienteSeleccionado: cliente_proveedor | any;

  /** Permite editar/guardar según rol (operación edición datos comerciales). */
  public puedeEditarSeccion = false;

  constructor(
    client: GraphQLClient,
    private clientesService: ClientesService,
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    public validadores: ValidadoresService,
    public rutService: RutService,
    public toastService: ToastService,
    private messageRendererService: MessageRendererService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService
  ) {
    this.log = this.clog.log('MANTENEDOR-CLIENTES/DATOS COMERCIALES')
    this.client = client;
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo());
    this.codigoModulo = 1;
    this.rutUsuario = Number(this.accesolocalstorage.getRutUsuario());
  }

  loadAndShow(cliente: cliente_proveedor) {
    this.clienteSeleccionado = cliente;
    this.clienteSeleccionado.rutFormato = this.rutService.AgregarDV(cliente.rut);
    this.formDatosComerciales.loadAndShow(cliente, () => {
      this.datosComercialesModal.show();
      this.aplicarPermisoEdicionComerciales();
    });
  }

  private aplicarPermisoEdicionComerciales() {
    const self = this;
    this.clientesService.rolOperacionPermitida(
      {
        rut_usu: self.rutUsuario,
        codgo_modulo: MANTENEDOR_CLIENTES_MODULO,
        cod_operacion: OP_EDICION_DATOS_COMERCIALES,
      },
      ({ mensajes }) => {
        self.puedeEditarSeccion =
          mensajes && mensajes.length > 0 && mensajes[0].tipo === TipoMensaje.SUCCESS;
        self.formDatosComerciales.setModoSoloLectura(!self.puedeEditarSeccion);
      }
    );
  }

  guardarDatosComercialesyFacturacion() {
    const self = this;
    this.clientesService.rolOperacionPermitida(
      {
        rut_usu: self.rutUsuario,
        codgo_modulo: MANTENEDOR_CLIENTES_MODULO,
        cod_operacion: OP_EDICION_DATOS_COMERCIALES,
      },
      ({ mensajes }) => {
        if (!mensajes || mensajes.length === 0 || mensajes[0].tipo !== TipoMensaje.SUCCESS) {
          self.messageRendererService.showErrors(mensajes);
          return;
        }
        self.ejecutarGuardarComerciales();
      }
    );
  }

  private ejecutarGuardarComerciales() {
    const valid = this.formDatosComerciales.validate();
    if (!valid) {
      this.toastService.error('Complete datos comerciales');
      return;
    }
    const self = this;

    const formData = this.formDatosComerciales.getFormData();
    this.log(formData)

    const clienteProveedor: any = {
      // rut: Number(this.formDatosComercialesyFacturadorE.get('rutCliente').value),
      rut: this.clienteSeleccionado.rut,
      empresa_rut: Number(self.rutEmpresa),

      nombre: formData.nombreFantasia,
      // nombre: formData.nombreFantasia,
      mail_intercambio: formData.emailIntercambio,
      mail_pdf: formData.usarMismoEmailContacto ? formData.emailContacto : formData.emailEnvioPdf,
      mail_contacto: formData.emailContacto,
      giro: formData.giroComercial,
      rut_usuario_actualiza: this.rutUsuario,
      moduloGrabacion: 3
    };

    // const bodyx = clienteProveedor;
    this.client.mutate(
      {
        mutation: gql`
          mutation($entidad: cliente_proveedorInputType) {
            cliente_proveedor {
              guardar(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  rut
                  nombre
                }
              }
            }
          }
        `,
        variables: {
          entidad: clienteProveedor,
        },
      },
      function (respuesta) {
        if (respuesta.data.cliente_proveedor.guardar.respuesta != null) {
          self.toastService.success('Registro grabado');
          self.onSuccess.emit();
          self.datosComercialesModal.hide();
        } else {
          self.messageRendererService.showErrors(respuesta.data.cliente_proveedor.guardar.mensajes);
        }
      }
    );
  }
}
